/**
 * @generated SignedSource<<c8d0043b1d2aa82e5c12cebdcd66a8fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutineOccasionSelectButton_workspaceRoutineOccasion$data = {
  readonly startAt: string;
  readonly storesCompletedCount: number;
  readonly storesCount: number;
  readonly " $fragmentType": "WorkspaceRoutineOccasionSelectButton_workspaceRoutineOccasion";
};
export type WorkspaceRoutineOccasionSelectButton_workspaceRoutineOccasion$key = {
  readonly " $data"?: WorkspaceRoutineOccasionSelectButton_workspaceRoutineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineOccasionSelectButton_workspaceRoutineOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceRoutineOccasionSelectButton_workspaceRoutineOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "storesCompletedCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "storesCount",
      "storageKey": null
    }
  ],
  "type": "RoutineWorkspaceOccasion",
  "abstractKey": null
};

(node as any).hash = "16bcdb9d7d3f786deee36c331a291212";

export default node;
